import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MaintenanceService } from '../@shared/services/maintenance.service';
import { ModalController } from '@ionic/angular';
import { MaintenanceWindowComponent } from '../@shared/components/maintenance-window/maintenance-window.component';

@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate {
  private modalOpen = false;

  constructor(
    private maintenanceService: MaintenanceService,
    private modalCtrl: ModalController,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    // Permitir acceso a rutas de autenticación sin verificar mantenimiento
    if (state.url.includes('/login') || state.url.includes('/register')) return true;

    let activeWin;
    try {
      activeWin = await this.maintenanceService.getActiveWindow();
    } catch (err) {
      // Si Firestore falla (permisos, red, colección inexistente), permitir acceso
      // para evitar que la app quede en blanco
      console.warn('MaintenanceGuard: no se pudo verificar ventana de mantenimiento', err);
      return true;
    }
    if (!activeWin) {
      this.maintenanceService.setAccess(false);
      return true;
    }

    // Si ya tiene acceso, permitir continuar
    if (this.maintenanceService.hasAccess()) {
      return true;
    }

    // Si hay ventana de mantenimiento activa, solicitar folio
    if (!this.modalOpen) {
      this.modalOpen = true;

      const modal = await this.modalCtrl.create({
        component: MaintenanceWindowComponent,
        componentProps: { window: activeWin },
        backdropDismiss: false,
      });

      modal.onDidDismiss().then((res) => {
        this.modalOpen = false;

        if (res.data === true) {
          this.maintenanceService.setAccess(true);
        } else {
          this.maintenanceService.setAccess(false);
          // Si está en home, no redirigir a login, solo bloquear acceso
          if (state.url !== '/home' && state.url !== '/') {
            this.router.navigate(['/home'], { queryParamsHandling: 'preserve' });
          }
        }
      });

      await modal.present();
    }

    // Permitir acceso pero el modal bloqueará la interacción
    return true;
  }
}
